<template>
  <a-card class="Analysis">
    <a-tabs v-model="active" :default-active-key="active" @change="callback" class="Analysis-tabs">
      <a-tab-pane :key="1" tab="营销数据">
        <MarketData v-if="active == 1"></MarketData>
      </a-tab-pane>
      <a-tab-pane :key="3" tab="游戏数据">
        <MirrorDataTabs v-if="active == 3"></MirrorDataTabs>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="健身镜游戏数据">
        <GmeAnalysis v-if="active == 2"></GmeAnalysis>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import MarketData from './components/marketData'
import GmeAnalysis from './components/gameAnalysis'
import MirrorDataTabs from './components/MirrorDataTabs'

import $Bus from '@/pages/projectImpl/js/eventBus'
export default {
  name: 'Analysis',
  components: { MarketData, GmeAnalysis, MirrorDataTabs },
  data() {
    return {
      active: 1,
    }
  },
  created() {
    if (this.$route.query.active) {
      this.active = +this.$route.query.active
    }
  },
  mounted() {},
  methods: {
    callback(e) {
      if (e == 1) {
        const arr = ['首页', '分析页', '营销数据']
        $Bus.$emit('pageHeaderBreadcrumb', arr)
      } else {
        const arr = ['首页', '分析页', '游戏数据']
        $Bus.$emit('pageHeaderBreadcrumb', arr)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.Analysis-tabs {
  overflow: auto;
  height: 72.5vh;
}
</style>
